import {ApiPublicErrorUtil, IApiPublicError, IApiPublicErrorTyped} from "../../common/ApiPublicError";
import {SortDirection} from "../../common/SortDirection";
import Sort from "../../../util/pattern/Sort";
import {SimulcastErrorAction} from "../../stream/simulcast/SimulcastTypes";

interface IFBErrorResponse {
    message: string;
    type: string;
    code: string;
    error_sub_code?: string | null;
    error_user_title?: string | null;
    error_user_msg?: string | null;
    fbtrace_id?: string | null;
}

enum FBErrorCode {
    APISession = "102",
    APIUnknown = "1",
    APIService = "2",
    APIMethod = "3",
    APITooManyCalls = "4",
    APIUserTooManyCalls = "17",
    APIPermissionDenied = "10",
    AccessTokenHasExpired = "190",
    APIPermissionRangeStart = "200",
    APIPermissionRangeEnd = "300",
    ApplicationLimitReached = "341",
    TempBlockPolicyViolation = "368",
    DuplicatePost = "506"
}

const FBErrorsReconnect: Set<string> = new Set([
    FBErrorCode.APISession,
    FBErrorCode.AccessTokenHasExpired
]);

const FBErrorsTryAgain: Set<string> = new Set([
    FBErrorCode.APIUnknown,
    FBErrorCode.APIService,
    FBErrorCode.APITooManyCalls,
    FBErrorCode.APIUserTooManyCalls,
    FBErrorCode.ApplicationLimitReached,
    FBErrorCode.TempBlockPolicyViolation
]);



// interface IFBPaging {
//     next: string | null;
// }

// interface IFBGroupsDataNode {
//     data: IFBGroupNode[];
//     paging: IFBPaging | null;
// }
//
//
// interface IFBEventsDataNode {
//     data: IFBEventNode[];
//     paging: IFBPaging | null;
// }


// interface IFBUserNode {
//     id: string;
//     name: string;
//     groups: IFBGroupsDataNode[];
//     events: IFBEventsDataNode[];
// }

interface IFBEventNode {
    id: string;
    name: string;
    start_time: string;
}

interface IFBEventNode {
    id: string;
    name: string;
    start_time: string;
}

interface IFBGroupNode {
    id: string;
    name: string;
    privacy: string | null;
}

interface IFBPageNode {
    id: string;
    access_token: string;
    category: string;
    name: string;
}

interface IFBLocations {
    id: string;
    name: string;
    events: IFBEventNode[];
    groups: IFBGroupNode[];
    pages: IFBPageNode[];
}

interface FBLocation {
    id: string;
    name: string;
    type: FBLocationType;
}

enum FBLocationType {
    USER = "USER",
    PAGE = "PAGE",
    GROUP = "GROUP",
    EVENT = "EVENT"
}



class FacebookUtil {


    static getFBErrorAction(errCode: string): SimulcastErrorAction {
        if(FBErrorsReconnect.has(errCode) || errCode.toLowerCase() == "OAuthException".toLowerCase()){
            return SimulcastErrorAction.Reconnect;
        } else if(FBErrorsTryAgain.has(errCode)){
            return SimulcastErrorAction.TryAgainLater;
        } else {
            return SimulcastErrorAction.Delete;
        }
    }

    static toFBError(err: IApiPublicError): IApiPublicErrorTyped<IFBErrorResponse> {
        return ApiPublicErrorUtil.toTypedError<IFBErrorResponse>("fberrorobj", err);
    }

    static getBestMsg(err: IApiPublicErrorTyped<IFBErrorResponse>): string {
        const objMsg = err.obj ? `${err.obj.message} (${err.obj.code}, ${err.obj.type})` : null;
        return objMsg || err.safeMsg;
    }

    static getDefaultLocation(locations: IFBLocations): FBLocation {
        if(locations.id && locations.name){
            return {id: locations.id, name: locations.name, type: FBLocationType.USER};
        } else {
            if(locations.pages.length > 0){
                return {id: locations.pages[0].id, name: locations.pages[0].name, type: FBLocationType.PAGE};
            } else if(locations.events.length > 0){
                return {id: locations.events[0].id, name: locations.events[0].name, type: FBLocationType.EVENT};
            }else if(locations.groups.length > 0){
                return {id: locations.groups[0].id, name: locations.groups[0].name, type: FBLocationType.GROUP};
            } else {
                throw Error('No default Facebook location available.');
            }
        }
    }

    static sortLocations(l: IFBLocations): void {
        l.pages.sort(Sort.getSortFn((p: IFBPageNode) => p.name, SortDirection.Asc));
        l.groups.sort(Sort.getSortFn((g: IFBGroupNode) => g.name, SortDirection.Asc));
        l.events.sort(Sort.getSortFn((e: IFBEventNode) => e.name, SortDirection.Asc));
    }

    static getLocationIdToType(l: IFBLocations): Map<string, FBLocationType> {
        const locationIdToType = new Map<string, FBLocationType>()
        locationIdToType.set(l.id, FBLocationType.USER)
        l.pages.forEach(p => locationIdToType.set(p.id, FBLocationType.PAGE));
        l.groups.forEach(g => locationIdToType.set(g.id, FBLocationType.GROUP));
        l.events.forEach(e => locationIdToType.set(e.id, FBLocationType.EVENT));
        return locationIdToType;
    }
}

export {IFBErrorResponse, IFBLocations, FBLocation, FacebookUtil, FBLocationType, IFBPageNode}